const AnimationTable = ({ activar, children }) => {
	return (
		<div
			style={{
				overflow: "hidden",
				transition: `
      max-height 0.6s cubic-bezier(0.4, 0, 0.2, 1),
      opacity 0.4s ease-in-out,
      transform 0.4s ease-out
    `,
				opacity: activar ? 1 : 0,
				maxHeight: activar ? "91vh" : "0", // en lugar de 100%
				transform: activar ? "translateY(0)" : "translateY(-8px)",
				pointerEvents: activar ? "auto" : "none",
				width: "98vw",
			}}
		>
			{children}
		</div>
	)
}

export default AnimationTable
